import _ from "lodash";

export const getCustomerId = (props: any = {}): number => {
    return Number(_.get(props, "match.params.cid") || _.get(props, "customer.id"));
};
